// Codes
export const ERROR_CODE_ASSET_LOADING = 'ASSET_LOADING_FAILED';
export const ERROR_UPC_ERROR = 'UPC_NOT_AVAILABLE';
export const ERROR_CODE_VALIDATION = 'VALIDATION_FAILED';
